import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';
const ContentPlayerContext = createContext();

export const ContentPlayerProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    open: false,
    courseId: null,
    contentId: null,
    returnUrl: null,
    currentContentId: null,
    onComplete: null,
    isLearnerMode: false,
    clrId: null,
    lpathId: null,
    onClose: null,
    searchQuery: null,
    queryId: null,
    isSearchResult: false,
    byContentId: false
  });

  // byContentId: contentId is the content's own ID, not its module's in the course (N40.1 pt 11).
  const openContentPlayer = useCallback((courseId, contentId, returnUrl, onComplete = null, isLearnerMode = false, clrId = null, lpathId = null, onClose = null, refreshOnClose = null, searchQuery = null, queryId = null, seek = null, isSearchResult = false, byContentId = false) => {
    setModalState({
      open: true,
      courseId,
      contentId,
      returnUrl,
      currentContentId: contentId,
      onComplete,
      isLearnerMode,
      clrId,
      lpathId,
      onClose,
      refreshOnClose,
      searchQuery,
      queryId,
      seek,
      isSearchResult,
      byContentId
    });
  }, []);

  const closeContentPlayer = useCallback(() => {
    // Call the onClose callback if it exists and is a function
    if (typeof modalState.onClose === 'function') {
      modalState.onClose();
    }

    setModalState(prev => ({
      ...prev,
      open: false,
      onClose: null,
      refreshOnClose: null,
      onComplete: null,
      searchQuery: null,
      queryId: null,
      currentContentId: null,
      isSearchResult: false,
      byContentId: false,
      seek: null
    }));
  }, [modalState]);

  const updateCurrentContent = useCallback((contentId, clrId = null) => {
    setModalState(prev => ({
      ...prev,
      currentContentId: contentId,
      clrId: clrId !== undefined ? clrId : prev.clrId
    }));
  }, []);

  // New function to mark content as completed
  const markContentCompleted = useCallback(async (contentId, clrId = null) => {
    try {
      // Call API to mark content as completed
      const response = await axios.post('/api/learner/content/completion', {
        content_id: contentId,
        clr_id: clrId,
        lpath_id: modalState.lpathId
      });      
      // If there's a completion callback in the modal state, call it
      if (modalState.onComplete && response.data.success) {
        modalState.onComplete(contentId);
      }     
      return response.data;
    } catch (error) {
      console.error('Error marking content as completed:', error);
      throw error;
    }
  }, [modalState]);

  return (
    <ContentPlayerContext.Provider
      value={{
        modalState,
        openContentPlayer,
        closeContentPlayer,
        updateCurrentContent,
        markContentCompleted
      }}
    >
      {children}
    </ContentPlayerContext.Provider>
  );
};

export const useContentPlayer = () => useContext(ContentPlayerContext);